module.exports = __webpack_public_path__ + "assets/images/magazine-gt_bb19385452550ac60e115be29cfb9703.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-four/exercise-5/magazine-gt.png
// module id = 281
// module chunks = 0